import yup from "@utils/validation/yup-extended";

export const CustomEmailSettingsSchema = yup.object().shape({
  email_username: yup.string().trim().max(80),
});
